import request from '@/utils/request'
// import { filters } from '@/filters/index.js'

export function getBaiduADList(params) {
  return request({
    url: `/baidu_ad/campaign_feed/list`,
    method: 'get',
    params
  })
}

export function getBaiduADProjectFeedList(params) {
  return request({
    url: `/baidu_ad/project_feed/list`,
    method: 'get',
    params
  })
}
// 账户列表
export function getBaiduADAccountList(params) {
  return request({
    url: `/baidu_ad/account/sub_list`,
    method: 'get',
    params
  })
}
// 账户列表-授权
export function AccountOauthUrl() {
  return request({
    url: `/baidu_ad/account/oauth_url`,
    method: 'get'
  })
}
export function getBaiduADCreativeFeedList(params) {
  return request({
    url: `/baidu_ad/creative_feed/list`,
    method: 'get',
    params
  })
}
// baidu
export function getBaiduADAdgroupFeedList(params) {
  return request({
    url: `/baidu_ad/adgroup_feed/list`,
    method: 'get',
    params
  })
}
// 同步账户资产
export function accountSync(data = {}) {
  return request({
    url: `/baidu_ad/account/sync`,
    method: 'post',
    data
  })
}
// 复制任务列表
export function job_list(params) {
  return request({
    url: `/baidu_ad/copy/job_list`,
    method: 'get',
    params
  })
}
// 图片列表
export function image_list(params) {
  return request({
    url: `/baidu_ad/assets/image_list`,
    method: 'get',
    params
  })
}
// 任务执行记录
export function job_record_list(params) {
  return request({
    url: `/baidu_ad/copy/job_record_list`,
    method: 'get',
    params
  })
}

// 视频列表
export function video_list(params) {
  return request({
    url: `/baidu_ad/assets/video_list`,
    method: 'get',
    params
  })
}
// 任务重试
export function retryFailedRecord(data = {}) {
  return request({
    url: `/baidu_ad/copy/retry_failed_record`,
    method: 'post',
    data
  })
}

// 停止广告复制
export function copyJobStop(data = {}) {
  return request({
    url: `/baidu_ad/copy/job_stop`,
    method: 'post',
    data
  })
}
// 删除图片
export function delImage(data = {}) {
  return request({
    url: `/baidu_ad/assets/del_image`,
    method: 'post',
    data
  })
}
// 删除视频
export function delVideo(data = {}) {
  return request({
    url: `/baidu_ad/assets/del_video`,
    method: 'post',
    data
  })
}
// 删除视频
export function job_create(data = {}) {
  return request({
    url: `/baidu_ad/copy/job_create`,
    method: 'post',
    data
  })
}
// 搜索词条
export function jmyPageList(params) {
  return request({
    url: `/baidu_ad/jmy_promotion_page/list`,
    method: 'get',
    params
  })
}
// 百度主账号
export function baiduPrimaryAccountList(params) {
  return request({
    url: `/baidu_ad/account/account_list`,
    method: 'get',
    params
  })
}

// 百度主账号修改token
export function updateBaiduToken(data) {
  return request({
    url: `/baidu_ad/account/update_token`,
    method: 'post',
    data
  })
}
// 百度账号-子账号同步
export function subUpdate(data) {
  return request({
    url: `/baidu_ad/account/sub_update`,
    method: 'post',
    data
  })
}
// 获取腾讯云配置
export function getQcConfig(params) {
  return request({
    url: '/sourceMaterial/qcConfig',
    method: 'get',
    params
  })
}
// 获取腾讯云可选域名
export function getQcDomains(params) {
  return request({
    url: '/sourceMaterial/domains',
    method: 'get',
    params
  })
}
// 获取预签名链接
// Query 参数
// domain string 域名
// key_path tring 文件路径

export function getQcSingnedUrl(params) {
  return request({
    url: '/sourceMaterial/qcSignedUrl',
    method: 'get',
    params
  })
}

